module.exports = __webpack_public_path__ + "img/everDemand.9ab0c178.png";